/**
 * Production'da console.log/warn devre dışı - performans için
 * Sadece development ortamında log yazılır
 */
const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    // Hataları her zaman logla (production'da da kritik hatalar görünsün)
    console.error(...args);
  },
};
